// Setup everything needed (Globals - 3rd party or otherwise to get the app ready to initialize)
import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import {initializeI18n} from '@netx/core-next/locales';
import './bootstrap';
import css from './css';

const logger = getPrefixedLogger('init');

// After i18n (success or fail) and custom css properties we will load the app
function loadApp() {
	// Initialize core
	import(/* webpackChunkName: "@netx/core" */ '@netx/core').then((Core) => {
		Core.default.initialize();
	});
}

logger.debug('initializing css and i18n');

Promise.all([
	// Load custom CSS before loading in core
	css(),
	// Load i18n and base locales before loading in core
	initializeI18n(),
])
	.then(
		() => {},
		(err) => {
			logger.error('failed to initialize css or i18n', err.message);
		},
	)
	.finally(() => {
		logger.debug('initialized');
		loadApp();
	});
